import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getProdutoFinalDoc, criaLinkVisualizacaoProduto, getLatestPdfInFolder, criaLinkVisualizacaoProdFinal,
  getLastDateStatus, postStatusAltConcluido, postStatusAltNaoIniciado, postStatusAltEntregue,
  getZipAndSaveInOikos,
  notifyExceedingBordero,
  createProductFolder,
  createProductsFoldersInProducao,
  createProductsFoldersInProdutosFinais,
  getProductsFromOikosToGrid,
  selectValues,
 } from '../../utils/fc/index.js';
 import oikosApi from '../../services/oikos';
import api_powerapps from '../../services/powerapps/index'
 import { graphClient } from '../../store/sagas/auth'
import qs from 'qs';
import { getMonthlyResult } from '../../store/ducks/financial';
import { Card, CardBody, Container, Input, Label } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import GanttChart from '../GanttChart/GanttChart';
import DragAndDrop from '../DragAndDropTest/DragAndDropTest.jsx';
import GridProductsCalendar from '../GridProductsCalendar/GridProductsCalendar.jsx';
import Select from '../Template/Input/Select.js';
import { TextareaAutosize } from '@mui/material';
import ModalFormDocumentos from '../Modals/ModalFormDocumentos/ModalFormDocumentos.jsx';
import TabelaEspacamentoPropItensTemporalEmMeses from '../TabelaEspacamentoPropItensTemporalEmMeses/TabelaEspacamentoPropItensTemporalEmMeses.jsx';
import TemporalStackedBarChart from '../TemporalStackedBarChart/TemporalStackedBarChart.jsx';

async function getProductIds(proj_id) {
  try {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        proj_id: proj_id
      },
    })}`)

    const prods = res.data;

    const listaIds = prods.map( (product) => {
      return product.prod_id
    })

    return listaIds;

  } catch (err) {
    console.log(err)
    console.log('nao foi possível capturar as datas dos status')
  }
}

async function getProjectsWithoutAprovement(list) {
  for (let item of list) {
    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'proj',
        data: {
          proj_id: item
        },
      })}`)

      const proj = res.data[0];

      console.log(proj.proj_nome)

      const res2 = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          proj_id: item
        },
      })}`)

      const prods = res2.data;

      for (let prod of prods) {

        if (!prod.prod_dtAprov && prod.prod_dtEntrega)
          console.log(prod.prod_desc)
      }

    } catch (err) {
      console.log(err)
      console.log('nao foi possível capturar as datas dos status')
    }
  }
}

const sendZipToServer = async () => {
  const helloTextContent = "Hello world! This is a test file.";

  try {
    const response = await fetch("http://104.198.77.243/testeEncryption2.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fileContent: helloTextContent }), // Send the text content
    });

    const result = await response.json();
    console.log("Response from server:", result);
  } catch (error) {
    console.error("Error:", error);
  }
};

async function getProdutosFaltantes() {
  const listaDeTodosIds = await getProductIds(1044)
  const listaProdId = [1806, 1803, 1799, 1800, 1801, 1802, 1805]

  const listaProdIdsFaltantes = listaDeTodosIds.filter(id => !listaProdId.includes(id))

  console.log(listaProdIdsFaltantes);
}

const TesteOneDrive = () => {
  const linhasTabelaExemplo = [
    { propItem_desc: 'Engenheiro ambiental (Hora)', propItem_id: 1,propItemGr_desc: 'Recursos Humanos', propOrcItem_valor: 15.68 },
    { propItem_desc: 'Biólogo (Hora)', propItem_id: 2, propItemGr_desc: 'Recursos Humanos', propOrcItem_valor: 12.68 },
    { propItem_desc: 'Geólogo (Hora)', propItem_id: 3, propItemGr_desc: 'Recursos Humanos', propOrcItem_valor: 15.48 },
    { propItem_desc: 'Carro (Km)', propItem_id: 4, propItemGr_desc: 'Logística', propOrcItem_valor: 55.58 },
    { propItem_desc: 'Van (Km)', propItem_id: 5, propItemGr_desc: 'Logística', propOrcItem_valor: 10.68 },
    { propItem_desc: 'GPS (Unidade)', propItem_id: 6, propItemGr_desc: 'Equipamentos', propOrcItem_valor: 1.68 },
    { propItem_desc: 'Notebook (Unidade)', propItem_id: 7, propItemGr_desc: 'Equipamentos', propOrcItem_valor: 0.68 },
  ];

  const [ objectToConsultProductsInSQL, setObjectToConsultProductsInSQL ] = useState({
    '2025-02' : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
    '2025-03' : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  });
  const [ nomeProjeto, setNomeProjeto ] = useState();
  const [ mes, setMes ] = useState([]);
  const [ products, setProducts ] = useState([]);
  const [ daysMonth, setDaysMonth ] = useState([]);
  const [ yearVar, setYearVar ] = useState(2025);
  const [ monthVar, setMonthVar ] = useState(1);
  const [inputs, setInputs] = useState([]);
  const [nomeTipoDocumento, setNomeTipoDocumento] = useState('');
  const [selectedTipoDocumentoId, setSelectedTipoDocumentoId] = useState(0);
  const [selTipoDoc, setSelTipoDoc] = useState(null);
  const [campos, setCampos] = useState([]);
  const [valoresCampos, setValoresCampos] = useState([]);
  const [chapter, setChapter] = useState('');
  const [chapters, setChapters] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [document, setDocument] = useState({});
  const [renderCustomFields, setRenderCustomFields] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const handleChange = (event) => {
    setSelectedType(event.target.value);
  };

  const handleAddChapter = () => {
    if (chapter.trim() !== '') {
      setChapters([...chapters, {titulo: chapter.trim(), subcapitulos: []}]);
      setChapter('');
    }
  };

  const handleRemoveChapter = (index) => {
    setChapters(chapters.filter((_, i) => i !== index));
  };


  useEffect(() => {
    //getGanttData(); objectToConsultProductsInSQL
    preloading();
    loadCampos();
  }, []);

  const preloading = async () => {
    setSelTipoDoc(await selectValues('tpDocumento', 'tpDocumento_id', 'tpDocumento_desc'));
  }

  const ordenarPorLabel = (lista) => {
    return lista.slice().sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    });
  }

  const loadCampos = async () => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'tpDocumentoCampo',
      data: {
        tpDocumento_id: 36
      },
    })}`);
    console.log('res', res.data);

    let resCampos = [...res.data];
    resCampos = resCampos.map(campo => ({
      ...campo, sm: 3
    }))

    for (const [index, campo] of resCampos.entries()) {
      console.log(campo, index)
      if (campo.formatoCampo_id === 1) {
        const selOptions = await selectValues(campo.tpDocumentoCampo_tabRef, `${campo.tpDocumentoCampo_tabRef}_id`, campo.tpDocumentoCampo_colunaRef)
        const selOptionsSorted = ordenarPorLabel(selOptions);
        resCampos[index].selOptions = selOptionsSorted;
      }
    }

    setCampos(resCampos);
  };

  const handleAddItem = () => {
    setInputs(prev => [...prev, {documentField_label: '', documentField_tabRef: '', documentField_columnRef: '', documentField_isRequired: false}]); // Adds 3 blank text fields
  };

  /*
  const handleChange = (index, field, value) => {
    const updated = [...inputs];
    updated[index][field] = value;
    setInputs(updated);
  };
  */

  const handleDeleteItem = (itemIndex) => {
    setInputs(prev => prev.filter((_, i) => i !== itemIndex));
  };

  const handleSubmit = async () => {

    let tables = [];

    for (const item of inputs) {
      tables.push(item.documentField_tabRef);
    }

    tables = JSON.stringify(tables);

    const tipoDocumentoResponse = await oikosApi.post('/', {
      action: 'insert',
      table: 'tpDocumento',
      data: {
        tpDocumento_desc: nomeTipoDocumento,
        tpDocumento_ativo: 1,
        tpDocumento_proprietario: tables,
        tpDocumento_usuarioCria: 141,
        tpDocumento_usuarioMod: 141,
        tpDocumento_dtCria: new Date().toISOString().slice(0, 19).replace('T', ' '),
        tpDocumento_dtMod: new Date().toISOString().slice(0, 19).replace('T', ' '),
      }
    })

    console.log(tipoDocumentoResponse.data);

    for (const item of inputs) {

      try {
        const response = await oikosApi.post('/', {
          action: 'insert',
          table: 'documentField',
          data: {
            tpDocumento_id: tipoDocumentoResponse.data[0].tpDocumento_id,
            documentField_tabRef: item.documentField_tabRef,
            documentField_columnRef: item.documentField_columnRef,
            documentField_isRequired: item.documentField_isRequired ? 1 : 0,
            documentField_label: item.documentField_label,
            documentField_usuarioCria: 141,
            documentField_usuarioMod: 141,
            documentField_dtCria: new Date().toISOString().slice(0, 19).replace('T', ' '),
            documentField_dtMod: new Date().toISOString().slice(0, 19).replace('T', ' '),
          }
        })
        console.log(response);

      } catch (error) {
        console.error('Error processing item:', item, error);
        break; // Skip to the next item if there's an error
      }
    }

    /*
    */
  }

  const handleChangeNomeTipoDocumento = (value) => {
    setNomeTipoDocumento(value);
  }

  const handleSubmitDocumento = () => {
    for (const campo of valoresCampos) {
      if(campo.documentField_isRequired && !campo.value) {

      }
    }
  }

  const getArrayMonthsYears = () => {
    document.getElementById('generateMonths').addEventListener('click', () => {
      const minDateInput = document.getElementById('minDate').value;
      const maxDateInput = document.getElementById('maxDate').value;

      if (!minDateInput || !maxDateInput) {
        console.error('Both minimum and maximum dates must be provided.');
        return;
      }

      const minDate = new Date(`${minDateInput}-01`);
      const maxDate = new Date(`${maxDateInput}-01`);

      console.log(minDate, maxDate);

      if (minDate > maxDate) {
        console.error('Minimum date cannot be greater than maximum date.');
        return;
      }

      const monthsObject = {};
      let currentDate = new Date(minDate);

      while (currentDate <= maxDate) {
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 2).toString().padStart(2, '0');
        const key = `${year}-${month}`;

        // Get the number of days in the current month
        const daysInMonth = new Date(year, currentDate.getMonth() + 2, 0).getDate();

        // Create an array of days
        monthsObject[key] = Array.from({ length: daysInMonth }, (_, i) => i + 1);

        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      console.log(monthsObject);

      setObjectToConsultProductsInSQL(monthsObject);
    });
  }

  const getGanttData = () => {
    const arrayOfDaysToConsultInSQL = getArrayOfDaysToConsultInSQL(objectToConsultProductsInSQL);
    getProducts(arrayOfDaysToConsultInSQL);
  }

  const getDaysInMonth = (monthParam, yearParam) => {
    const days = [];
    const daysInMonth = new Date(yearParam, monthParam, 0).getDate();
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({day: i, dayWeek: new Date(yearParam, monthParam, i).getDay()});
    }

    setDaysMonth(days);
    return days;
  }

  const getArrayOfDaysToConsultInSQL = (obj) => {
    const arrayDaysToConsultInSQL = [];
    Object.keys(obj).forEach(key => {
      obj[key].forEach(
        day => {
          arrayDaysToConsultInSQL.push(`${key}-${day <= 9 ? `0${day}` : `${day}`}`);
        }
      )
    });

    console.log(arrayDaysToConsultInSQL);

    return arrayDaysToConsultInSQL;
  }

  const atualizaGraficoMes = (mes) => {
    setMes(mes + 1);
  }

  /*
  const handleChange = (e) => {
    atualizaGraficoMes(e)
    console.log(`Você selecionou o mês ${e}!`)
    //this.setState({extratoModalIsOpen: true})
  }
  */

  const getProducts = async (arrayOfDaysToConsultInSQL) => {
    const productsFromOikos = await getProductsFromOikosToGrid(arrayOfDaysToConsultInSQL)
    setProducts(productsFromOikos)
  }

  const monthlyResult = [
    {
        "mes": "01/2024",
        "acumulado": 297370.45999999996,
        "resultado": 297370.45999999996,
        "despesa": 574407.87,
        "receita": 871778.33
    },
    {
        "mes": "02/2024",
        "acumulado": 221503.3999999999,
        "resultado": -75867.06000000006,
        "despesa": 542041.06,
        "receita": 466174
    },
    {
        "mes": "03/2024",
        "acumulado": 277902.57999999984,
        "resultado": 56399.179999999935,
        "despesa": 567838.93,
        "receita": 624238.11
    },
    {
        "mes": "04/2024",
        "acumulado": 120993.29999999981,
        "resultado": -156909.28000000003,
        "despesa": 643959.53,
        "receita": 487050.25
    },
    {
        "mes": "05/2024",
        "acumulado": 52511.19999999984,
        "resultado": -68482.09999999998,
        "despesa": 597581.76,
        "receita": 529099.66
    },
    {
        "mes": "06/2024",
        "acumulado": 13110.179999999818,
        "resultado": -39401.02000000002,
        "despesa": 615735.3,
        "receita": 576334.28
    },
    {
        "mes": "07/2024",
        "acumulado": -72144.15000000014,
        "resultado": -85254.32999999996,
        "despesa": 576121.09,
        "receita": 490866.76
    },
    {
        "mes": "08/2024",
        "acumulado": 11555.39999999979,
        "resultado": 83699.54999999993,
        "despesa": 681608.4,
        "receita": 765307.95
    },
    {
        "mes": "09/2024",
        "acumulado": -109550.54000000015,
        "resultado": -121105.93999999994,
        "despesa": 616024.07,
        "receita": 494918.13
    },
    {
        "mes": "10/2024",
        "acumulado": -46129.35000000009,
        "resultado": 63421.19000000006,
        "despesa": 655397.69,
        "receita": 718818.88
    },
    {
        "mes": "11/2024",
        "acumulado": -225917.21000000008,
        "resultado": -179787.86,
        "despesa": 926237.67,
        "receita": 746449.81
    },
    {
        "mes": "12/2024",
        "acumulado": 131749.7479869998,
        "resultado": 357666.9579869999,
        "despesa": 755582.67,
        "receita": 1113249.627987
    }
  ]

  const getDataFinanceiro = async () => {
    const formData = {
      'acao': 'dashboard_financeiro_projeto',
      'nivel3_id': 774,
    }
    const res = await api_powerapps.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    console.log(res)
  }

  const serieAcumulado = monthlyResult.map(item => item.acumulado)
  const serieReceita = monthlyResult.map(item => item.receita)
  const serieDespesa = monthlyResult.map(item => item.despesa)
  const serieResultado = monthlyResult.map(item => item.resultado)
  const serieLabel = monthlyResult.map(item => item.mes)

  /*
  */
  const options = {
    labels: serieLabel,
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: function(event, chartContext, config) {
          //console.log(config['dataPointIndex'])
          handleChange(config['dataPointIndex'])
        }
      },
    },
    stroke: {
      width: [0, 0, 0, 4],
      curve: 'smooth',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    colors: ['#5664d2', '#1cbb8c', '#ffff00', '#3fa3ff'],
    yaxis: [{
      seriesName: 'Receita',
      labels: {
        formatter: (value) => {
          return value.toFixed(0)
        },
      },
      show: true,
      title: {
        text: 'Receita',
      },
    }, {
      seriesName: 'Receita',
      show: false,
      title: {
        text: 'Despesa',
      },
    }, {
      show: false,
      seriesName: 'Receita',
      title: {
        text: 'Resultado',
      },
    }, {
      opposite: true,
      labels: {
        formatter: (value) => {
          return value.toFixed(0)
        },
      },
      title: {
        text: 'Acumulado',
      },
    }],
  }

  const series = [{
    name: 'Receita',
    type: 'column',
    data: serieReceita,
  }, {
    name: 'Despesa',
    type: 'column',
    data: serieDespesa,
  }, {
    name: 'Resultado',
    type: 'column',
    data: serieResultado,
  }, {
    name: 'Acumulado',
    type: 'line',
    data: serieAcumulado,
  }]

  const listaDeProdutosStatusConcluido = [
    1637
    ,1638
    ,1639
    ,1640
    ,1641
    ,1642
    ,1643
    ,1644
    ,1645
    ,1654
    ,1655
    ,1656
    ,1657
    ,1658
    ,1806
    ,1928
    ,1929
    ,1930
    ,1931
    ,1932
    ,1933
    ,1934
    ,1935
    ,1936
    ,1937
    ,1938
    ,1939
    ,1940
    ,1941
    ,1942
    ,1943
    ,1944
    ,2440
    ,2441
    ,2442
    ,2443
    ,2444
    ,2445
    ,2446
    ,2447
    ,2448
    ,2449
    ,2450
    ,2451
    ,2452
  ]
  const listaDeProdutosStatusNaoIniciado = [
    2412,
    2413,
    2414,
    2415,
    2416,
    2417,
    2418,
    2419,
    2420,
    2421,
    2422,
    2423,
  ]
  const listaDeProdutosStatusEntregue = []

  const handleCopyFolders = async () => {
    async function copyProductFolders() {
      const failedFolders = []; // Array to store names of folders where the process fails

      const targetUser = await graphClient.api(`/users/admin@ecossis.com.br`).get();
      const targetDriveId = targetUser.id;

      try {
        // Step 1: Get all project folders inside "Projetos"
        const projetosFolders = await graphClient.api('/me/drive/root:/Projetos:/children').get();
        const projects = projetosFolders.value.filter((item) => item.folder);

        // Step 2: Iterate through each project folder
        for (let project of projects) {
          if (
            project.name === 'PGA Aratu Candeias CODEBA' ||
            project.name === 'PGA Salvador CODEBA'
          ) {
            const produtosFinaisPath = `/me/drive/root:/Projetos/${project.name}/7 - Produtos Finais:/children`;

            try {
              // Step 3: Get all folders inside "7 - Produtos Finais"
              const produtosFinaisFolders = await graphClient.api(produtosFinaisPath).get();
              const productFolders = produtosFinaisFolders.value.filter((item) => item.folder);

              console.log(productFolders, project.name);

              // Step 4: Create each folder in the corresponding project folder in "Biblioteca de produtos"
              for (let productFolder of productFolders) {
                try {
                  // Fetch the 'Biblioteca de produtos' folder
                  const bibliotecaDeProdutoFolder = await graphClient.api('/me/drive/root/children')
                  .filter(`name eq 'Biblioteca de produtos'`)
                  .get();

                  console.log(bibliotecaDeProdutoFolder, 'aaaaaaaaaaaaaa');

                  // Fetch corresponding project folder in Biblioteca de Produtos
                  const bibliotecaDeProdutosProjetoFolders = await graphClient
                    .api(`/me/drive/items/${bibliotecaDeProdutoFolder.value[0].id}/children`)
                    .filter(`name eq '${project.name}'`)
                    .get();

                  // Create the product folder inside the corresponding project folder
                  const postProductFolderInBibliotecaDeProdutos = await graphClient
                    .api(`/me/drive/items/${bibliotecaDeProdutosProjetoFolders.value[0].id}/children`)
                    .post({
                      name: productFolder.name,
                      folder: {},
                      '@microsoft.graph.conflictBehavior': 'fail'
                    });

                  console.log(`${postProductFolderInBibliotecaDeProdutos}`);
                } catch (folderError) {
                  console.error(`Failed to get the folder "${productFolder.name}" in "Biblioteca de produtos": ${folderError.message}`);
                  failedFolders.push(`${project.name}/7 - Produtos Finais/${productFolder.name}`);
                }
              }
            } catch (projectError) {
              console.error(`Failed to process project folder "${project.name}": ${projectError.message}`);
              failedFolders.push(`${project.name}/7 - Produtos Finais`);
            }
          } // Close if statement here for project.name check
        } // Close for loop here

        if (failedFolders.length > 0) {
          console.log('The following folders failed to process:');
          failedFolders.forEach((folder) => console.log(folder));
        } else {
          console.log('All folders processed successfully.');
        }
      } catch (error) {
        console.error('An error occurred:', error.message);
      }
    }

    await copyProductFolders(); // Ensure the asynchronous function is awaited properly
  };

  const handleCreateFolder = async () => {
    const targetUserEmail = 'admin@ecossis.com.br'; // Replace with the target user's email

    await createProductFolder(targetUserEmail, 'teste')
    await createProductsFoldersInProducao(743, 'teste');
    await createProductsFoldersInProdutosFinais(743, 'teste');
  };

  const handleLink = async () => {
    const link = await getProdutoFinalDoc('https://ecossissolucoes-my.sharepoint.com/:f:/g/personal/admin_ecossis_com_br/ErnyAUgIbXlMjt9cCcJovjMB-HA4xhgMt6AL91wTnMohlA?e=rWkaVj', 'admin@ecossis.com.br');
    console.log(link)
  }

  const handleDocToPdf = async () => {
  }

  const handleVisualizacaoLink = async () => {
    const lastestPdf = await getLatestPdfInFolder('https://ecossissolucoes-my.sharepoint.com/:f:/g/personal/admin_ecossis_com_br/ErnyAUgIbXlMjt9cCcJovjMB-HA4xhgMt6AL91wTnMohlA?e=rWkaVj', 'admin@ecossis.com.br');
    criaLinkVisualizacaoProdFinal(lastestPdf, "admin@ecossis.com.br")
  }

  const handleGetLastDateStatus = async () => {
    const lastestDate = await getLastDateStatus(2, 1427);
    console.log(lastestDate);
  }

  const handleGetProducts = async () => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        prod_id: 1935
      },
      fields: {
        '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = prod.prod_responsavel)': 'prod_responsavel_email',
        '(SELECT proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)': 'proj_nome',
        '(SELECT pf.pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT psa.prodStatusAlt_usuarioCria FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id ORDER BY psa.prodStatusAlt_dtCria DESC LIMIT 1))': 'prodStatusAlt_usuarioMovimentacao',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusActual_id',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)': 'prodStatusPenultimo_id',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6 )': 'hasStatus6',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 5)': 'hasStatus5',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 4)': 'hasStatus4',
      }
    })}`);

    console.log(res.data);

    await getZipAndSaveInOikos(res.data[0].prod_drive, res.data[0]);

    console.log("produto salvo");
  }

  const handleGetProjectsWithoutAprovement = async () => {
    await getProjectsWithoutAprovement([273, 1017, 1044, 1068, 1074, 1087, 1089, 1096, 1101, 1123, 1125, 1128, 1135, 1144, 1145, 1155, 1157, 1158, 1178, 1181, 1182, 1189, 1218, 1219, 1235, 1249, 1251, 1253, 1254, 1256, 1257, 1264, 1266, 1268, 1269, 1270, 1272, 1273, 1274, 1275, 1276, 1278])
  }

  const handleEmailBordero = async () => {
    await notifyExceedingBordero({desc: 'balbalbal', valor: 'R$ 120,00', orcamentoInfoMes: {Saldo: 1200, orcado: 200, previsto: 300}})
  }

  const handleStatusConcluido = async () => {


    listaDeProdutosStatusConcluido.map( async (produtoId) => {
      const lastestDate = await postStatusAltConcluido(produtoId);
      console.log(lastestDate);
    })
    /*
    listaDeProdutosStatusNaoIniciado.map( async (produtoId) => {
      const lastestDate = await postStatusAltNaoIniciado(produtoId);
      console.log(lastestDate);
    })
    */

   /*
    listaDeProdutosStatusEntregue.map( async (produtoId) => {
      const lastestDate = await postStatusAltEntregue(produtoId);
      console.log(lastestDate);
    })
    */
  }

  const taskManager = async (orcItem) => {

    const taskBodyMother = {
      action: 'insert',
      table: 'task',
      data: {
        task_desc: `Suplementação para ${orcItem}`,
        pf_id: 141,
        task_usuarioCria: 141,
        task_usuarioMod: 141,
      }
    }

    const taskMotherCreated = await oikosApi.post('/', taskBodyMother);

    const taskBody = {
      action: 'insert',
      table: 'task',
      data: {
        task_desc: `Suplementação para ${orcItem}`,
        task_mae: taskMotherCreated.data[0].task_id,
        pf_id: 141,
        task_usuarioCria: 141,
        task_usuarioMod: 141,
      }
    }

    const taskCreated = await oikosApi.post('/', taskBody);

    console.log(taskMotherCreated);
    console.log(taskCreated);
  }

  const fetchPJs = async () => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pj',
      order: 'pj_cnpj'
    })}`);
    console.log('res', res.data[0]);

    for (let index = 0; index < res.data.length; index++) {
      const element = res.data[index];

      if(element.pj_cnpj && element.pj_cnpj !== '' && (!element.pj_razaosocial || element.pj_razaosocial === '')) {
        const apenasNumeros = String(element.pj_cnpj).replace(/\D/g, "");
        const fetchPjFromApi = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${apenasNumeros}`);

        const infoPjFromApi = await fetchPjFromApi.json();

        console.log(String(infoPjFromApi.cnpj))

        if (infoPjFromApi.razao_social && !element.pj_razaosocial) {
          const body = {
            action: 'update',
            table: 'pj',
            data: {
              pj_id: element.pj_id,
              pj_razaosocial: (infoPjFromApi.razao_social.replace("'", '')),
            }
          }
          const res = await oikosApi.post('/', body);
          console.log('updated', res)
        }
      }
    }

  }

  return (
    <Container fluid>
      <TemporalStackedBarChart
        style={{paddingTop: '20rem'}}
        data={{
          '1': {
            0: {
              eventoPagamentoProp_nome: 'entrada 1',
              eventoPagamentoProp_vlr: 100.00
            },
            1: {
              eventoPagamentoProp_nome: 'produto 1',
              eventoPagamentoProp_vlr: 150.00
            },
            2: {
              eventoPagamentoProp_nome: 'produto 2',
              eventoPagamentoProp_vlr: 250.00
            }
          },
          '2': {
            0: {
              eventoPagamentoProp_nome: 'produto 3',
              eventoPagamentoProp_vlr: 400.00
            }
          },
          '3': {
            0: {
              eventoPagamentoProp_nome: 'entrada 1',
              eventoPagamentoProp_vlr: 100.00
            },
            1: {
              eventoPagamentoProp_nome: 'produto 1',
              eventoPagamentoProp_vlr: 150.00
            },
            2: {
              eventoPagamentoProp_nome: 'produto 2',
              eventoPagamentoProp_vlr: 250.00
            }
          },
          '4': {
            0: {
              eventoPagamentoProp_nome: 'produto 3',
              eventoPagamentoProp_vlr: 400.00
            }
          }
        }}
        valueKey={'eventoPagamentoProp_vlr'}
        labelKey={'eventoPagamentoProp_nome'}
        timeKeyType='month'
      />
    </Container>

  );
};

export default TesteOneDrive;
